/**
 * Invite links are funneled through splash (main.js's loadSplash) — the one
 * unauth landing mvvLegit allows in every auth state, including the brand-new
 * state 0 of a cold incognito load. Whether the current page IS an invite
 * landing is decided by ?uid=&token= in the query string, not by the URL
 * hash/route name — the hash stays #/splash (or #/) the whole time.
 *
 * Pulled out as its own function because this exact condition used to be
 * implemented twice, independently, and the two implementations diverged:
 * main.js checked the query string (correct); AuthController.js's mvvLegit
 * nav-guard checked the hash for '#/accept-invite' (a route that is never
 * actually navigated to), so the guard could never fire. One source of
 * truth here removes that class of drift.
 *
 * @param {string} [search] - defaults to window.location.search
 * @returns {boolean}
 */
export function isInviteLink(search = window.location.search) {
  const params = new URLSearchParams(search || '');
  return !!(params.get('uid') && params.get('token'));
}
